import { GetterTree } from "vuex";
import { IDataProvider, IRootState } from "@/store";
import {
  ITransferAuthority,
  ITransferAuthorityState,
} from "@/store/modules/transferAuthority/state";

export enum TransferAuthorityGetters {
  GET_ALL = "GET_ALL_TRANSFER_AUTHORITY",
  GET_CURRENT = "GET_CURRENT_TRANSFER_AUTHORITY",
  GET_DATA_PROVIDER = "GET_DATA_PROVIDER_TRANSFER_AUTHORITY",
}

export const getters: GetterTree<ITransferAuthorityState, IRootState> = {
  [TransferAuthorityGetters.GET_ALL](state): ITransferAuthority[] | null {
    return state.transferAuthorities;
  },
  [TransferAuthorityGetters.GET_CURRENT](state): ITransferAuthority | null {
    return state.transferAuthority;
  },
  [TransferAuthorityGetters.GET_DATA_PROVIDER](
    state
  ): IDataProvider<ITransferAuthority> | null {
    return state.dataProvider;
  },
};
